module.exports = "https://s.pinimg.com/webapp/style/images/ES@2x-c4229401.png";